import { serializeError } from '@mono-farmart-web/common-utils/utils/serializeError';
import { logger } from '@mono-farmart-web/logger';

const NETWORK_ERROR_MESSAGES = [
	'failed to fetch',
	'load failed',
	'networkerror when attempting to fetch resource',
	'failed network request',
	'network request failed',
];

const isExplicitlyOfflineNetworkError = (error: unknown): boolean => {
	if (typeof navigator === 'undefined' || navigator.onLine !== false)
		return false;

	const message = serializeError(error).toLowerCase();
	return NETWORK_ERROR_MESSAGES.some(pattern => message.includes(pattern));
};

/**
 * API callers choose the reporting level. Only recognized network failures
 * while the browser explicitly reports offline stay out of Sentry.
 */
export const reportApiError = (
	error: unknown,
	metadata: Record<string, unknown>,
): void => {
	const message = serializeError(error);
	if (isExplicitlyOfflineNetworkError(error)) {
		logger.info(message, metadata);
		return;
	}

	logger.err(error instanceof Error ? error : new Error(message), metadata);
};
